import { BREAKPOINTS_EXTENDED } from '@/constants/Core';
import isEmpty from "lodash/isEmpty";
import { Children } from "react";

export const reorderChildren = (children, windowWidth) => {

    const w = windowWidth;

    //check if children has order props, if not return children as is
    if (children?.length <= 1 || isEmpty(children)) 
        return children;

    const hasOrderProps = children?.some(child => {
        return (
            child.props.order 
            || child.props.orderXs 
            || child.props.orderSm 
            || child.props.orderMd 
            || child.props.orderLg 
            || child.props.orderXl 
            || child.props.orderXxl
        );
    });

    if (!hasOrderProps) 
        return children;

    const ordered = [];
    
    Children.forEach(children, (child, index) => {
        const {props} = child;
        
        const {order = null, orderXs = null, orderSm = null, orderMd = null, orderLg = null, orderXl = null, orderXxl = null} = props;
        
        let orderValue = order;

        if (w >= BREAKPOINTS_EXTENDED.xs && w <= BREAKPOINTS_EXTENDED.sm && orderXs)
            orderValue = orderXs;

        if (w >= BREAKPOINTS_EXTENDED.sm && w <= BREAKPOINTS_EXTENDED.md && orderSm)
            orderValue = orderSm;
        
        if (w >= BREAKPOINTS_EXTENDED.md && w <= BREAKPOINTS_EXTENDED.lg && orderMd)
            orderValue = orderMd;

        if (w >= BREAKPOINTS_EXTENDED.lg && w <= BREAKPOINTS_EXTENDED.xl && orderLg)
            orderValue = orderLg;

        if (w >= BREAKPOINTS_EXTENDED.xl && w <= BREAKPOINTS_EXTENDED.xxl && orderXl)
            orderValue = orderXl;

        if (w >= BREAKPOINTS_EXTENDED.xxl && orderXxl)
            orderValue = orderXxl;

        if (orderValue === null)
            orderValue = order || index +1;

        
        orderValue = orderValue - 1;
        ordered[orderValue] = child;
    });

    return ordered;
}